module.exports = __webpack_public_path__ + "img/slide_4.f776857c.png";